import { render, staticRenderFns } from "./StartLogo.vue?vue&type=template&id=109e540d&"
import script from "./StartLogo.vue?vue&type=script&lang=js&"
export * from "./StartLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports